import { Injectable } from '@angular/core';

@Injectable()
export class TripManifestService {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/trip-manifest/trip-manifest.service.ts